export default { 
  h72454535fdcd56d02161be0d4ab4ce2d: [[({}, []) => ["Fingerprint Login enabled!"], {}]],
  h9ac5c3aeb970b2c119698e4e668d5f9a: [[({}, []) => ["Got it"], {}]],
  hb16f116b99718fb4c13d0c908a3485bd: [[({}, []) => ["Face ID Login enabled!"], {}]],
  hb3cc6678aa1025fb604cc3dbd9729289: [[({}, [C0]) => ["To change or disable your", " ", C0(), " Login go to", " "], {}]] 
}